var map = {
	"./anquanzheng-.svg": 624,
	"./bumen-.svg": 625,
	"./chengbaoshang-.svg": 626,
	"./gongsi-.svg": 627,
	"./jiankangzheng-.svg": 628,
	"./jituna-.svg": 629,
	"./shanggangzheng-.svg": 630,
	"./tuandui-.svg": 631,
	"./xiangmu-.svg": 632,
	"./xinxi-.svg": 633
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 634;


//////////////////
// WEBPACK FOOTER
// ./src/svg ./~/xml-loader! ^\.\/.*\.svg$
// module id = 634
// module chunks = 16